import React, { Component } from 'react';
import Clients from '../../components/css/dark/img/theme-images/clients.svg';
import ReportPopup from '../../components/Wholesaler/ReportPopup';
import MinimumPayoutReportPopup from '../../components/Wholesaler/MinimumPayoutReport';
import CommissionPayoutAllBinJDPopup from '../../components/Wholesaler/CommissionPayoutAllBinJD';
import TransitionReportPopup from '../../components/Wholesaler/TransitionReportPopup';
import WholesalerCommissionReportPopup from '../../components/Wholesaler/WhCommissionReport';
import MonthlyClaimsReport from '../../components/Wholesaler/MonthlyClaimsReport';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import $ from 'jquery';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";

class Reports extends Component {
    constructor(props) {
        super(props);
        try {
            this.state = {
                DisshowPopup: false,
                WhCommissionPopup: false,
                MinimumPayoutReport: false,
                userdata: JSON.parse(localStorage.getItem('user')),
                toggleTransitionsPopup: false,
                CommissionPayoutAllBinJD: false,
                MonthlyClaimsPopUp: false
            };
        }
        catch (error) { }
    }
    toggleDisPopup() {
        if (this.state.DisshowPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    DisshowPopup: !this.state.DisshowPopup,
                });
            }, 500)
        } else {
            this.setState({
                DisshowPopup: !this.state.DisshowPopup,
            });
        }
    }
    wholesalerCommissionPopup() {
        if (this.state.WhCommissionPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    WhCommissionPopup: !this.state.WhCommissionPopup,
                });
            }, 500)
        } else {
            this.setState({
                WhCommissionPopup: !this.state.WhCommissionPopup,
            });
        }
    }
    toggleMinimumPayoutPopup() {
        if (this.state.MinimumPayoutReport === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    MinimumPayoutReport: !this.state.MinimumPayoutReport,
                });
            }, 500)
        } else {
            this.setState({
                MinimumPayoutReport: !this.state.MinimumPayoutReport,
            });
        }
    }
    toggleCommissionPayoutAllBinJD() {
        if (this.state.CommissionPayoutAllBinJD === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    CommissionPayoutAllBinJD: !this.state.CommissionPayoutAllBinJD,
                });
            }, 500)
        } else {
            this.setState({
                CommissionPayoutAllBinJD: !this.state.CommissionPayoutAllBinJD,
            });
        }
    }
    wholesalerMonthlyClaimsPopup() {
        if (this.state.MonthlyClaimsPopUp === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    MonthlyClaimsPopUp: !this.state.MonthlyClaimsPopUp,
                });
            }, 500)
        } else {
            this.setState({
                MonthlyClaimsPopUp: !this.state.MonthlyClaimsPopUp,
            });
        }
    }
    componentDidMount() {
        $(".analytics-menu").click(e => {
            if ($('.collapseButton').hasClass("active")) {
                this.handleCollapse();
                $('.sidebar-submenu').show();
                $('body').toggleClass('sub-menu-active');
            }
        });
        setTimeout(() => {
            const hasScrollbar = document.body.scrollHeight > window.innerHeight;
            if (!hasScrollbar) {
                $('body').addClass('hide-scroller');
            }
        }, 300);
    }
    componentWillUnmount() {
        $('body').removeClass('hide-scroller');
    }
    toggleTransitionsPopup() {
        $('body').toggleClass('transitionCalendar');
        var wname = this.state.userdata.wholesaler;
        var wholesaler_Id = this.state.userdata.wholesaler_Id;
        var unique_ObjectId = this.state.userdata.unique_ObjectId;
        if (this.state.toggleTransitionsPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    toggleTransitionsPopup: !this.state.toggleTransitionsPopup,
                    dashboardName: wname,
                    wholesaler_Id: wholesaler_Id,
                    unique_ObjectId: unique_ObjectId
                });
            }, 500)
        } else {
            this.setState({
                toggleTransitionsPopup: !this.state.toggleTransitionsPopup,
                dashboardName: wname,
                wholesaler_Id: wholesaler_Id,
                unique_ObjectId: unique_ObjectId
            });
        }
    }
    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css({ 'width': 'auto', 'overflow': 'visible' });
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function () {
                $(".collapseButton").removeClass('active');
            });
            $(".tool-section").animate({
                marginLeft: 313 + 'px'
            }, 1000);
            $(".sidebar-section").removeClass('intro');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function () {
                $(".menu-text").css({ 'width': '0px', 'overflow': 'hidden' });
                $('.sidebar-submenu').hide();
                if ($('body').hasClass("sub-menu-active")) {
                    $('body').toggleClass('sub-menu-active');
                }
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function () {
                $(".collapseButton").addClass('active')
            });
            $(".tool-section").animate({
                marginLeft: 133 + 'px'
            }, 1000);
            $(".sidebar-section").addClass('intro');
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }
    render() {
        try {
            let usertype = userService.Get_User_Type();
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
            if (usertype.toLowerCase() == 'admin') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'distributor') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'subadmin') {
                return <Redirect to='/pageNotFound' />
            }
        } catch (error) { }
        return (
            <div>
                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                <Header />
                <Sidebar AnalyticList={this.props.AnalyticData} />
                <div className="tool-section report">
                    <h2>Reports <span className="beta-link"><span className="beta">Beta</span></span></h2>
                    {
                        this.state.userdata.wholesaler == "Avenel_llll" ?
                            <ul>

                                <li><div className="manage-content"><img src={Clients} alt="" />Coming Soon<span className="arrow">&nbsp;</span></div></li>

                            </ul> : null
                    }

                    {
                        this.state.userdata.wholesaler != "Avenel_llll" ?
                            <ul>

                                <li onClick={this.toggleDisPopup.bind(this)}><div className="manage-content"><img src={Clients} alt="" />Commission <br />Payout Report<span className="arrow">&nbsp;</span></div></li>
                                {
                                    this.state.userdata.username === "JD Gibson" || this.state.userdata.wholesaler_Id == 61 ?
                                        <li onClick={this.toggleMinimumPayoutPopup.bind(this)}><div className="manage-content"><img src={Clients} alt="" />Minimum <br />Payout Report<span className="arrow">&nbsp;</span></div></li>
                                        : null
                                }
                                {
                                    this.state.userdata.username === "JD Gibson" || this.state.userdata.wholesaler_Id == 61 ?
                                        <li onClick={this.toggleCommissionPayoutAllBinJD.bind(this)}><div className="manage-content"><img src={Clients} alt="" />Commission <br />Payout Report(All Bins)<span className="arrow">&nbsp;</span></div></li>
                                        : null
                                }
                                <li onClick={this.toggleTransitionsPopup.bind(this)}><div className="manage-content"><img src={Clients} alt="" />Generate Raw <br />Transaction Report<span className="arrow">&nbsp;</span></div></li>
                                <li onClick={this.wholesalerCommissionPopup.bind(this)}><div className="manage-content"><img src={Clients} alt="" />Wholesaler <br />Commission Report<span className="arrow">&nbsp;</span></div></li>
                                {
                                    this.state.userdata.username === this.state.userdata.username ?
                                        <li onClick={this.wholesalerMonthlyClaimsPopup.bind(this)}><div className="manage-content"><img src={Clients} alt="" />Monthly Claims Report<span className="arrow">&nbsp;</span></div></li>
                                        : null
                                }
                            </ul> : null
                    }

                    {
                        this.state.DisshowPopup ?
                            <ReportPopup text='Commission Payout Report' closePopup={this.toggleDisPopup.bind(this)} /> : null
                    }
                    {
                        this.state.WhCommissionPopup ?
                            <WholesalerCommissionReportPopup text='Wholesaler Commission Report' closeCommissionPopup={this.wholesalerCommissionPopup.bind(this)} /> : null
                    }
                    {
                        this.state.MinimumPayoutReport ?
                            <MinimumPayoutReportPopup text='Minimum Payout Report' closePopup={this.toggleMinimumPayoutPopup.bind(this)} /> : null
                    }
                    {
                        this.state.CommissionPayoutAllBinJD ?
                            <CommissionPayoutAllBinJDPopup text='Commission Payout Report(All Bins)' closePopup={this.toggleCommissionPayoutAllBinJD.bind(this)} /> : null
                    }
                    {
                        this.state.toggleTransitionsPopup ?
                            <TransitionReportPopup text='Generate Raw Transaction Report' calldata={"callonce"} closeRawTransactionPopup={this.toggleTransitionsPopup.bind(this)} wholesaler_name={this.state.dashboardName} wholeSaler_id={this.state.wholesaler_Id} unique_ObjectId={this.state.unique_ObjectId} /> : null
                    }
                    {
                        this.state.MonthlyClaimsPopUp ?
                            <MonthlyClaimsReport text='Monthly Claims Report' calldata={"callonce"} closeMonthlyClaimsPopup={this.wholesalerMonthlyClaimsPopup.bind(this)} wholesaler_name={this.state.dashboardName} wholeSaler_id={this.state.wholesaler_Id} unique_ObjectId={this.state.unique_ObjectId} /> : null
                    }
                </div>
            </div>
        )

    }

}
export default Reports;